export default {
    "event_admin": ['event'],
    "admin": ["event", "basic"],
}


// WEBPACK FOOTER //
// ./src/libs/role.js